<template>
    <div v-if="ready">
        <button @click="handleImprimir" class="btn btn-primary mt-5 ms-3" style="color: aliceblue;">Generar Excel <i
                class="fa-solid fa-download"></i></button>
    </div>
    <div class="container d-flex justify-content-center align-items-center text-center">

        <table class="table table-striped table-hover text-center" id="myTable">
            <thead>
                <tr>
                    <th>ID</th>
                    <th class="text-center">Beneficiario</th>
                    <th class="text-center">No.Referencia</th>
                    <th>Monto</th>
                    <th>Fecha Pagado</th>
                    <th class="text-center">IFI</th>
                    <th>No. Cuenta</th>
                    <th>Sucursal</th>
                    <th>Imagen</th>
                </tr>
            </thead>
            <tbody v-if="ready">
                <tr v-for="pago in pagos" :key="pago.id">
                    <td>{{ pago.id }}</td>
                    <td>{{ pago.nombreCliente }}</td>
                    <td>{{ pago.noReferenciaRecibo }}</td>
                    <td>{{ this.formatoNumero(pago.montoPagado) }} {{ this.moneda }}</td>
                    <td>{{ this.dateFormat(pago.fechaPagado) }}</td>
                    <td>{{ pago.ifi }}</td>
                    <td>{{ pago.noCuenta }}</td>
                    <td>{{ pago.sucursal }}</td>
                    <td>

                        <!-- Button trigger modal -->
                        <button type="button" class="btn btn-primary" @click="pagoSlug(pago.slug)"
                            data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <i class="fa-solid fa-image" style="color:white"></i>
                        </button>
                    </td>
                </tr>

            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="10" class="text-center">
                        <div class="spinner-border text-warning text-center" role="status">
                            <span class="visually-hidden text-center">Loading...</span>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="table-dark">

                    <td class="text-end"></td>
                    <td class="text-end"></td>
                    <td class="pt-4 pb-4"> <strong>Total Pagado:</strong> </td>
                    <td>{{ this.formatoNumero(this.totalMontoPagado) }} {{ this.moneda }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>

                    </td>
                </tr>
            </tfoot>




        </table>
        <!-- Modal -->
        <div class="modal fade " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">Recibo</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex justify-content-center align-items-center">
                            <!-- <pdf-recibo :imgPath="imgPath" :pago="pago" class="me-3"></pdf-recibo> -->
                            <div class="contenedor">
                                <img class="imagen-recibo" :src="imgPath + '/recibo/' + pago.slug + '.jpg'"
                                    alt="Recibo">
                                <!-- <a :href="imgPath + '/recibo/' + pago.slug + '.pdf'" download>pdf</a>
                                <img :src="imgPath + '/recibo/' + pago.slug + '.jpg'" alt="Recibo"> -->

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";
import DataTables from "datatables.net";
import ExcelJS from "exceljs";


export default {
    data() {
        return {
            ready: false,
            pagos: [],
            moneda: "lps",
            imgPath: process.env.VUE_APP_IMAGE_URL,
            totalMontoPagado: 0,
            pago: {
                slug: ''
            }
        }
    },
    props: {
        startDate: new Date,
        endDate: new Date,
        option: Boolean,
    },
    watch: {
        startDate: function () {
            // console.log('date', date)
            this.getPagosByRange()
        },
        endtDate: function () {
            // console.log('date', date)
            this.getPagosByRange()
        }
    },
    beforeMount() {
        if (this.option) {
            this.getPagosByRange()
        } else {
            this.getAllReadecuted()
        }
    },
    updated() {
        if (this.ready) {
            this.initializeDataTable();
        }


    },
    methods: {
        getPagosByRange() {
            this.ready = false

            let payload = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            fetch(process.env.VUE_APP_API_URL + `/admin/pagos/allByRange`, Security.requestOptions(payload))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {

                        // this.pagos = response.data.pagos.reverse();
                        this.pagos = response.data.pagos;
                        this.ready = true
                        console.log('Pagos Hecho:', this.pagos);
                        this.calculateTotalMonto()

                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },
        getAllReadecuted() {
            this.ready = false

            fetch(process.env.VUE_APP_API_URL + `/admin/pagos/allReadecuated`, Security.requestOptions({}))
                .then((response) => response.json())
                .then((response) => {
                    if (response.error) {
                        Swal.fire({
                            position: 'top-end',
                            icon: "error",
                            title: response.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });

                    } else {

                        // this.pagos = response.data.pagos.reverse();
                        this.pagos = response.data.pagos;
                        this.ready = true
                        console.log('Pagos Hecho:', this.pagos);
                        this.calculateTotalMonto()

                    }
                })
                .catch(error => {
                    Swal.fire({
                        position: 'top-end',
                        icon: "error",
                        title: error,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                });
        },
        initializeDataTable() {
            console.log('Despues Iniciar');
            const myTable = document.querySelector("#myTable");
            if (myTable) {
                new DataTables(myTable);
            }


        },
        calculateTotalMonto() {
            this.totalMontoPagado = 0; // Reset total
            if (this.pagos) {
                this.pagos.forEach(pago => {
                    this.totalMontoPagado += pago.montoPagado;
                });
            }
        },
        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US").format(numero)
        },
        formatoNumero2(numero) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numero);
        },

        dateFormat(param) {

            var fechaISO = param;


            // Crear un objeto Date con la fecha proporcionada
            var fecha = new Date(fechaISO);

            // Obtener el día del mes (agregando un cero inicial si es necesario)
            var dia = ('0' + fecha.getUTCDate()).slice(-2);

            // Obtener el mes (agregando un cero inicial si es necesario)
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

            // Obtener el año
            var anio = fecha.getUTCFullYear();

            // Formatear la fecha según tus necesidades
            var fechaFormateada = dia + '/' + mes + '/' + anio;

            console.log(fechaFormateada); // Salida: 01/12/2023

            return fechaFormateada;

        },
        pagoSlug(slug) {
            this.pago.slug = slug
        },

        handleImprimir() {
            let i1 = 0, i2 = 0, i3 = 0;

            for (let i = 0; i < this.pagos.length; i++) {
                if (this.pagos[i].interesCredito == 8.7) {
                    i1 = 43.0; i2 = 46.0; i3 = 11.0;
                } else {
                    i1 = 41.5; i2 = 41.5; i3 = 17.0;
                }
                this.pagos[i].i1 = i1;
                this.pagos[i].i2 = i2;
                this.pagos[i].i3 = i3;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(this.depto ? this.depto[0] : "Data");

            worksheet.columns = [
                { header: "Beneficiario", key: "beneficiario", width: 40 },
                { header: "No Referencia recibo", key: "noReferencia", width: 20 },
                { header: "Total Monto", key: "monto", width: 20 },
                { header: "Capital Pago", key: "capitalPago", width: 20 },
                { header: "Interes Pago", key: "interesPago", width: 20 },
                { header: "Interes ahdeco", key: "i1", width: 20 },
                { header: "Interes senprende", key: "i2", width: 20 },
                { header: "Reserva de cuentas incobrables", key: "i3", width: 20 },
                { header: "Interes Credito ", key: "interesCredito", width: 20 },
                { header: "Mora Pago", key: "moraPago", width: 20 },
                { header: "Fecha Pagado", key: "fechaPagado", width: 20 },
                { header: "IFI", key: "ifi", width: 20 },
                { header: "No. Cuenta", key: "noCuenta", width: 20 },
                { header: "Sucursal", key: "sucursal", width: 20 },
                { header: "Usuario Encargado", key: "usuario", width: 20 },
                { header: "Pago Realizado por", key: "usuarioPago", width: 20 },
            ];

            worksheet.getRow(1).font = { bold: true };

            const mappedData = this.pagos.map((pago) => ({
                beneficiario: pago.nombreCliente,
                noReferencia: pago.noReferenciaRecibo,
                monto: pago.montoPagado,
                capitalPago: pago.capitalPago,
                interesPago: pago.interesPago,
                i1: parseFloat((pago.interesPago * (pago.i1 / 100)).toFixed(2)),
                i2: parseFloat((pago.interesPago * (pago.i2 / 100)).toFixed(2)),
                i3: parseFloat((pago.interesPago * (pago.i3 / 100)).toFixed(2)),
                interesCredito: pago.interesCredito,
                moraPago: pago.moraPago,
                fechaPagado: new Date(pago.fechaPagado),  // FECHA COMO OBJETO
                ifi: pago.ifi,
                noCuenta: pago.noCuenta,
                sucursal: pago.sucursal,
                usuario: (pago.encargado && pago.encargado !== 'Andrés Molina') ? pago.encargado : '',
                usuarioPago: (pago.nombreUsuario && pago.nombreUsuario !== 'Andrés Molina') ? pago.nombreUsuario : '',
            }));

            worksheet.addRows(mappedData);

            // FORMATO DE FECHA
            worksheet.getColumn('fechaPagado').numFmt = 'dd/mm/yyyy';

            // CONVERTIR A TABLA CON FILTROS
            worksheet.addTable({
                name: 'PagosTable',
                ref: 'A1',
                headerRow: true,
                style: {
                    theme: 'TableStyleMedium2',
                    showRowStripes: true,
                },
                columns: worksheet.columns.map(col => ({ name: col.header, filterButton: true })),
                rows: mappedData.map(row => worksheet.columns.map(col => row[col.key])),
            });

            // DESCARGAR ARCHIVO
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", `Pagos-${this.dateFormat(this.startDate)}-${this.dateFormat(this.endDate)}.xlsx`);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });
        },

    },

}
</script>

<style scoped>
.modal-img> :not(caption)>*>* {
    padding: 0.5rem 0.5rem;
    background-color: white;
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.imagen-recibo {
    width: 100%;
}

button {
    margin-top: 0;
}
</style>
